import React from 'react'
// import PropTypes from 'prop-types'

/**
 * Composant qui affiche un tiret stylisé lorsqu'une valeur est manquante ou vide.
 * 
 * @param {Object} props - Les propriétés du composant
 * @param {string|number|null|undefined} props.value - La valeur à afficher
 * @param {string} props.className - Classes CSS additionnelles
 * @returns {React.ReactElement} Un composant qui affiche la valeur ou un tiret stylisé
 */
const EmptyValuePlaceholder = ({ value, className = '' }) => {
  const isEmpty = value === undefined || value === null || value === ''
  
  if (isEmpty) {
    return (
      <span className={`text-sm text-gray-400 italic ${className}`}>
        —
      </span>
    )
  }
  
  return <span className={className}>{value}</span>
}

// EmptyValuePlaceholder.propTypes = {
//   value: PropTypes.any,
//   className: PropTypes.string
// }

export default EmptyValuePlaceholder